// 地区id
export const placeId = 1
// 地名管理 id
export const BasicList = {
    '1_1': 1, // 门牌管理
    '1_2': 2, // 路牌管理
    '1_4': 4, // 景区管理
    '1_5': 5, // 道路管理
    '101': 3, // 地名遗产
}
// 信息管理 id
export const cententList = {
    '6_1':11, // 瑞安概况
    '6_2':12, // 行政区划
    '6_3':13, // 地名咨询
    '6_4':14, // 地名展览
    '6_5':15, // 影像地名
    '6_6':16, // 地名研究
    '6_7':17, // 红色地名
    '6_8':18, // 地名遗产
    '6_11':27 // 攻略
}
// 高德地图 key
export const amapkey = "a6c0b1d91f80cff868c940ee8021b60c"
